import omit from 'lodash/fp/omit';
import type { UserProfile } from 'oidc-client-ts';
import type { RioUserProfile } from './loginSlice';

const stripSnakeProps = (obj: UserProfile) => omit(['family_name', 'given_name', 'client_id'])(obj);

export const mapUserProfile = (profile: UserProfile): RioUserProfile => ({
    ...stripSnakeProps(profile),
    aud: profile.aud,
    email: profile.email,
    familyName: profile.family_name,
    givenName: profile.given_name,
    locale: profile.locale,
    name: profile.name,
    sub: profile.sub,
});
